import { evaluateConditions } from 'features/libra/conditions/evaluateCondition'
import { FieldValues } from 'features/libra/ontology/ontologyFieldTypes'
import { Condition } from 'features/libra/sections/formLayout'

export const getVisibleSectionIds = (
  form: ReadonlyArray<{
    sectionId: string
    showWhen: ReadonlyArray<Condition>
  }>,
  fieldValues: FieldValues
): ReadonlyArray<string> => {
  return form
    .filter(({ showWhen }) => evaluateConditions(showWhen, fieldValues))
    .map(({ sectionId }) => sectionId)
}
